var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { postJson, putJson, withDone, withValidate, withMap, deleteJson } from '@rad/utility/http';
import { arrayBufferToBase64, getMimeTypeFromFilename } from '@rad/utility/formatting';
import { BLOB_BASE } from '../constants';
const fileToSerializable = (file, sortOrder) => __awaiter(void 0, void 0, void 0, function* () {
    const buffer = yield file.arrayBuffer();
    return {
        name: file.name,
        size: file.size,
        contentType: getMimeTypeFromFilename(file.name),
        contentBase64: arrayBufferToBase64(buffer),
        sortOrder,
    };
});
const filesToSerializable = (files, sortStart) => __awaiter(void 0, void 0, void 0, function* () { return Promise.all(files.map((f, i) => fileToSerializable(f, sortStart + i + 1))); });
export const serializeFile = (file) => fileToSerializable(file, 0);
export const map = (x) => x.map((a) => (Object.assign(Object.assign({}, a), { url: `${BLOB_BASE}/${a.storagePath}` })));
export const create = (kind, files, sortStart) => __awaiter(void 0, void 0, void 0, function* () {
    const fs = yield filesToSerializable(files, sortStart);
    return withDone(withValidate(withMap(postJson(`/api/attachments`, { kind, files: fs }), map)))();
});
export const update = (f, propertyId) => withDone(withValidate(putJson(`/api/attachments`, Object.assign(Object.assign({}, f), { propertyId }))))();
export const setHeaderVariant = (assetId, attachmentId) => withDone(withValidate(withMap(postJson(`/api/attachments/set-header`, { assetId, attachmentId }), (a) => map([a])[0])))();
/** Saves a photo's crop; answers it as saved, with the zoomed copy the server made for it. */
export const setFocus = (id, crop) => withDone(withValidate(withMap(putJson(`/api/attachments/${id}/focus`, crop), (saved) => (Object.assign(Object.assign({}, crop), { zoomedUrl: saved.zoomedCopy === null ? undefined : map([saved.zoomedCopy])[0].url })))))();
export const softDelete = (f) => withDone(withValidate(deleteJson(`/api/attachments`, f)))();
export const uploadFile = (file, kind) => __awaiter(void 0, void 0, void 0, function* () {
    const [success, result] = yield create(kind, [file], 0);
    if (success) {
        return { id: result[0].id, url: `${BLOB_BASE}/${kind}/${result[0].id}` };
    }
    return null;
});
